import React from 'react'
import { Main } from './components'

const LocationMovements = () => <Main />

export default LocationMovements
